import Post from "../Post";
import getToken from "../token";

export default function newBlogRequest(title, description, links) {
  return Post("blog/requestBlog", {
    token: getToken(),
    title: title,
    descreptions: description,
    url: links,
  });
}
